import { combineSlices, configureStore } from '@reduxjs/toolkit';
import type { Middleware } from '@reduxjs/toolkit';

import { apiSlice } from './apiSlice';
import { chatSlice } from './chatSlice';
import { commonSlice } from './commonSlice';
import { dialogSlice } from './dialogSlice';
import { gqlApiSlice } from './gqlApiSlice';
import { sessionLostSlice } from './sessionLostSlice';
import { websocketSlice } from './websocketSlice';
import { windowSlice } from './windowSlice';

export const rootReducer = combineSlices(
  gqlApiSlice,
  apiSlice,
  // signupSlice,
  commonSlice,
  chatSlice,
  dialogSlice,
  websocketSlice,
  windowSlice,
  sessionLostSlice
);

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(apiSlice.middleware, gqlApiSlice.middleware as Middleware),
  devTools: process.env.NODE_ENV === 'development',
});

export type RootState = ReturnType<typeof rootReducer>;
export type AppDispatch = typeof store.dispatch;
